'use strict'

import angular from 'angular'
import ListController from './list.controller'

export default angular.module('onyxReadingRoomApp.deviceconfigs.list', [])
  .controller('DeviceConfigsListController', ListController)
  .name



// WEBPACK FOOTER //
// ./client/app/deviceconfigs/list/index.js